import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type Visita = {
  numero: string;
  marca: string;
  isoCodigo: string;
  isoTamano: number;
  isoTipo: string;
  noHacerAltaLibre: boolean;
  tieneCertificadoImo: boolean;
  notificacionImo: boolean;
};

type VacioImportBody = {
  visitas: Visita[];
  codigoArmador: string;
  tipoDeDocumento: string;
  esProforma: boolean;
  rutTitular: string;
  liquidando: boolean;
  lavado: string;
  oidLiquidacion: number;
};

type ApiResponse = {
  isSuccess: boolean;
  value: unknown;
};

export const addContainerBlVacioImport = async (
  body: VacioImportBody
): Promise<ApiResponse['value']> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.AddContainersBLVacioImport,
      body
    );

    if (!res.data.isSuccess) {
      throw new Error('Error al agregar contenedor vacío import');
    }

    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
